/* Messe-Shop24 – Großbestellung / Angebotsanfrage (4-Schritt-Assistent)
   Herkunft: sections/main-product.liquid (Canopy 6.3.1 live, Z. 2237–2680), 1:1 übernommen 2026-10-04.
   Eigene Datei: wird von Canopy-Updates nicht überschrieben. */
(function () {
  var modal = document.getElementById('bulkModal');
  if (!modal) return;

  var body       = document.getElementById('bulk-form-body');
  var footer     = document.getElementById('bulk-form-footer');
  var stepper    = document.getElementById('bulk-stepper');
  var backBtn    = document.getElementById('bulk-back');
  var nextBtn    = document.getElementById('bulk-next');
  var submitBtn  = document.getElementById('bulk-submit');
  var dsgvoBlock = document.getElementById('bulk-dsgvo-block');
  var closeBtn   = document.getElementById('bulkModalClose');

  var steps = Array.prototype.slice.call(modal.querySelectorAll('.bulk-step'));
  var items = Array.prototype.slice.call(modal.querySelectorAll('.bulk-step-item'));
  var last  = steps.length - 1;
  var current = 0;
  var maxReached = 0;

  /* ---------- Schrittsteuerung ---------- */
  function showStep(n) {
    current = n;
    if (n > maxReached) maxReached = n;

    steps.forEach(function (s, i) { s.classList.toggle('is-active', i === n); });
    items.forEach(function (it, i) {
      it.classList.toggle('is-active', i === n);
      it.classList.toggle('is-done', i < maxReached && i !== n);
      it.disabled = i > maxReached;
    });

    backBtn.style.display    = n === 0    ? 'none' : '';
    nextBtn.style.display    = n === last ? 'none' : '';
    submitBtn.style.display  = n === last ? '' : 'none';
    dsgvoBlock.style.display = n === last ? '' : 'none';

    if (body) body.scrollTop = 0;
  }

  /* Prüft nur die sichtbaren Felder des Schritts */
  function validateStep(n) {
    var fields = steps[n].querySelectorAll('input, select, textarea');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      if (f.offsetParent === null) continue;      /* eingeklappte Felder überspringen */
      if (!f.checkValidity()) { f.reportValidity(); return false; }
    }
    return true;
  }

  /* Vorwärts nur über gültige Schritte; rückwärts immer erlaubt */
  function goTo(target) {
    if (target > current) {
      for (var i = current; i < target; i++) {
        showStep(i);
        if (!validateStep(i)) return;
      }
    }
    showStep(target);
  }

  nextBtn.addEventListener('click', function () { goTo(current + 1); });
  backBtn.addEventListener('click', function () { showStep(current - 1); });
  items.forEach(function (it) {
    it.addEventListener('click', function () {
      if (!this.disabled) goTo(parseInt(this.dataset.goto, 10));
    });
  });

  /* Beim Absenden: zum Schritt mit dem ungültigen Feld springen */
  var form = document.getElementById('bulk-contact-form');
  if (form) {
    form.addEventListener('invalid', function (e) {
      var st = e.target.closest('.bulk-step');
      if (st) {
        var i = steps.indexOf(st);
        if (i !== -1 && i !== current) showStep(i);
      }
    }, true);
  }

  /* ---------- Öffnen / Schließen ---------- */
  function openModal() {
    prefillVariant();
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.bulk-order-trigger')) {
      e.preventDefault();
      openModal();
      return;
    }
    if (e.target && e.target.id === 'bulkSuccessClose') closeModal();
  });

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  /* ---------- Variante + SKU aus der URL übernehmen ---------- */
  var varianteEl    = document.getElementById('bulk-variante');
  var skuInput      = document.getElementById('bulk-sku');
  var wunschBlock   = document.getElementById('bulk-variante-wunsch-block');
  var wunschInput   = document.getElementById('bulk-variante-wunsch');
  var isSelect      = !!varianteEl && varianteEl.tagName === 'SELECT';

  /* SKU + Freitextfeld an die gewählte Variante angleichen */
  function syncVariante() {
    if (!isSelect) return;
    var opt = varianteEl.options[varianteEl.selectedIndex];
    if (skuInput) skuInput.value = opt ? (opt.dataset.sku || '') : '';

    var isAndere = !!opt && !opt.dataset.variantId;
    if (wunschBlock) {
      wunschBlock.classList.toggle('is-visible', isAndere);
      if (wunschInput) {
        wunschInput.required = isAndere;
        if (isAndere && modal.classList.contains('is-open')) wunschInput.focus();
      }
    }
  }
  if (isSelect) varianteEl.addEventListener('change', syncVariante);

  /* Beim Öffnen die auf der Produktseite gewählte Variante übernehmen */
  function prefillVariant() {
    if (!varianteEl) return;
    var id = new URLSearchParams(window.location.search).get('variant');

    if (isSelect) {
      if (id) {
        for (var i = 0; i < varianteEl.options.length; i++) {
          if (varianteEl.options[i].dataset.variantId === String(id)) {
            varianteEl.selectedIndex = i;
            break;
          }
        }
      }
      syncVariante();
      return;
    }

    /* Fallback: Produkt ohne Varianten -> Textfeld */
    var variants = window.__productVariants || [];
    if (!id || !variants.length) return;
    for (var j = 0; j < variants.length; j++) {
      if (String(variants[j].id) === String(id)) {
        varianteEl.value = variants[j].title || '';
        if (skuInput) skuInput.value = variants[j].sku || '';
        break;
      }
    }
  }

  /* ---------- Datepicker Minimum = morgen ---------- */
  var dateInput = document.getElementById('bulk-lieferdatum');
  if (dateInput) {
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    dateInput.min = tomorrow.toISOString().split('T')[0];
  }

  /* ---------- Erfolgsseite nach Absenden ---------- */
  if (window.location.search.indexOf('bulk_sent=true') !== -1) {
    var successBody = document.getElementById('bulk-success-body');
    if (body)        body.style.display = 'none';
    if (footer)      footer.style.display = 'none';
    if (stepper)     stepper.style.display = 'none';
    if (successBody) successBody.style.display = '';
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    history.replaceState(null, '', window.location.pathname);
  }

  /* ---------- Produktsuche für "Weitere Artikel" ---------- */
  (function () {
    var input    = document.getElementById('bulk-suche');
    var results  = document.getElementById('bulk-search-results');
    var pickedEl = document.getElementById('bulk-picked');
    var freitext = document.getElementById('bulk-weitere-freitext');
    var hidden   = document.getElementById('bulk-weitere-artikel');
    if (!input || !results || !pickedEl || !hidden) return;

    var url    = input.dataset.searchUrl;
    var picked = [];
    var timer;

    function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }

    /* Shopify-CDN-URLs tragen schon ?v=… — Breite deshalb anhängen, nicht ersetzen */
    function thumb(u) {
      if (!u) return '';
      if (u.indexOf('//') === 0) u = 'https:' + u;
      return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=96';
    }

    function imageOf(p) {
      if (p.featured_image && p.featured_image.url) return p.featured_image.url;
      if (typeof p.image === 'string') return p.image;
      if (p.image && p.image.url) return p.image.url;
      return '';
    }

    function absolute(u) {
      if (!u) return '';
      return u.indexOf('http') === 0 ? u : window.location.origin + u;
    }

    /* Versteckte Zeile bauen — genau das landet in der Angebots-Mail */
    function syncHidden() {
      var lines = picked.map(function (p) {
        var menge = (p.qty || '').toString().trim();
        return p.title + (menge ? ' — ' + menge + ' Stück' : '') + ' · ' + absolute(p.url);
      });
      var extra = freitext ? freitext.value.trim() : '';
      if (extra) lines.push(extra);
      hidden.value = lines.join('\n');
    }

    function renderPicked() {
      pickedEl.innerHTML = '';
      picked.forEach(function (p, idx) {
        var li = document.createElement('li');
        li.className = 'bulk-picked-item';
        li.innerHTML =
          (p.image ? '<img class="bulk-picked-img" src="' + esc(thumb(p.image)) + '" alt="" loading="lazy">' : '') +
          '<span class="bulk-picked-title">' + esc(p.title) + '</span>' +
          '<input type="number" class="bulk-picked-qty" min="1" step="1" inputmode="numeric" placeholder="Menge" value="' + esc(p.qty) + '" aria-label="Menge für ' + esc(p.title) + '">' +
          '<button type="button" class="bulk-picked-remove" aria-label="' + esc(p.title) + ' entfernen">✕</button>';

        li.querySelector('.bulk-picked-qty').addEventListener('input', function () {
          picked[idx].qty = this.value;
          syncHidden();
        });
        li.querySelector('.bulk-picked-remove').addEventListener('click', function () {
          picked.splice(idx, 1);
          renderPicked();
          syncHidden();
        });
        pickedEl.appendChild(li);
      });
    }

    function add(p) {
      if (picked.some(function (x) { return x.url === p.url; })) return;   /* keine Dubletten */
      picked.push({ title: p.title, url: p.url, image: imageOf(p), qty: '1' });
      renderPicked();
      syncHidden();
      input.value = '';
      closeResults();
      input.focus();
    }

    function closeResults() { results.classList.remove('is-open'); }
    function message(text) {
      results.innerHTML = '<div class="bulk-search-msg">' + esc(text) + '</div>';
      results.classList.add('is-open');
    }

    function render(products) {
      if (!products.length) { message('Keine Treffer — beschreib den Artikel einfach unten im Textfeld.'); return; }
      results.innerHTML = '';
      products.forEach(function (p) {
        var img = imageOf(p);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bulk-result';
        btn.innerHTML =
          (img ? '<img class="bulk-result-img" src="' + esc(thumb(img)) + '" alt="" loading="lazy">'
               : '<span class="bulk-result-img"></span>') +
          '<span class="bulk-result-text">' +
            '<span class="bulk-result-title">' + esc(p.title) + '</span>' +
            (p.product_type ? '<span class="bulk-result-meta">' + esc(p.product_type) + '</span>' : '') +
          '</span>';
        btn.addEventListener('click', function () { add(p); });
        results.appendChild(btn);
      });
      results.classList.add('is-open');
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = this.value.trim();
      if (q.length < 2) { closeResults(); return; }

      timer = setTimeout(function () {
        var params = 'q=' + encodeURIComponent(q)
          + '&' + encodeURIComponent('resources[type]') + '=product'
          + '&' + encodeURIComponent('resources[limit]') + '=6'
          + '&' + encodeURIComponent('resources[options][fields]') + '=' + encodeURIComponent('title,product_type,variants.title,variants.sku,vendor')
          + '&' + encodeURIComponent('resources[options][unavailable_products]') + '=last';

        fetch(url + '?' + params, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var res = d && d.resources && d.resources.results;
            render((res && res.products) || []);
          })
          .catch(function () {
            message('Suche gerade nicht erreichbar — beschreib den Artikel unten im Textfeld.');
          });
      }, 300);
    });

    /* Escape schließt erst die Trefferliste, nicht gleich das ganze Modal */
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && results.classList.contains('is-open')) {
        e.stopPropagation();
        closeResults();
      }
      if (e.key === 'Enter') {
        e.preventDefault();                       /* kein versehentliches Absenden */
        var first = results.querySelector('.bulk-result');
        if (first) first.click();
      }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.bulk-search-wrap')) closeResults();
    });

    if (freitext) freitext.addEventListener('input', syncHidden);
  })();

  /* ---------- Auswahl-Karten: Optik + immer Ja/Nein senden ---------- */
  modal.querySelectorAll('.bulk-check-card input[type="checkbox"]').forEach(function (cb) {
    var card   = cb.closest('.bulk-check-card');
    var hidden = document.getElementById(cb.dataset.valueTarget || '');
    function sync() {
      card.classList.toggle('is-checked', cb.checked);
      if (hidden) hidden.value = cb.checked ? 'Ja' : 'Nein';
    }
    cb.addEventListener('change', sync);
    sync();
  });

  /* ---------- Abweichende Lieferadresse ---------- */
  var abwCheckbox = document.getElementById('bulk-abw-adresse');
  var lieferBlock = document.getElementById('bulk-lieferadresse-block');
  if (abwCheckbox && lieferBlock) {
    abwCheckbox.addEventListener('change', function () {
      lieferBlock.classList.toggle('is-visible', this.checked);
      if (this.checked) {
        var first = document.getElementById('bulk-liefer-firma');
        if (first) first.focus();
      }
    });
  }

  /* ---------- Adress-Autocomplete via OpenStreetMap (kein API-Key) ---------- */
  function attachAutocomplete(streetInput, plzInput, ortInput) {
    if (!streetInput) return;

    var dropdown = document.createElement('ul');
    dropdown.style.cssText = [
      'position:absolute','z-index:10000','background:#fff',
      'border:1.5px solid #d1d5db','border-radius:8px',
      'box-shadow:0 8px 24px rgba(0,0,0,0.12)','margin:4px 0 0',
      'padding:4px 0','list-style:none','width:100%',
      'max-height:220px','overflow-y:auto','font-size:14px','display:none'
    ].join(';');
    streetInput.parentElement.style.position = 'relative';
    streetInput.parentElement.appendChild(dropdown);

    var debounceTimer;

    streetInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var query = this.value.trim();
      if (query.length < 4) { dropdown.style.display = 'none'; return; }

      debounceTimer = setTimeout(function () {
        fetch(
          'https://nominatim.openstreetmap.org/search'
          + '?format=json&addressdetails=1&limit=6&countrycodes=de'
          + '&q=' + encodeURIComponent(query),
          { headers: { 'Accept-Language': 'de' } }
        )
        .then(function (r) { return r.json(); })
        .then(function (results) {
          dropdown.innerHTML = '';
          if (!results.length) { dropdown.style.display = 'none'; return; }

          results.forEach(function (item) {
            var a          = item.address;
            var strasse    = a.road || '';
            var hausnummer = a.house_number || '';
            var plz        = a.postcode || '';
            var ort        = a.city || a.town || a.village || a.municipality || '';
            if (!strasse || !plz) return;

            var li = document.createElement('li');
            li.style.cssText = 'padding:10px 14px;cursor:pointer;line-height:1.4;border-bottom:1px solid #f3f4f6;';
            li.innerHTML =
              '<span style="font-weight:600;color:#111827">' + strasse + (hausnummer ? ' ' + hausnummer : '') + '</span>' +
              '<span style="color:#6b7280;font-size:13px;display:block">' + plz + ' ' + ort + '</span>';

            li.addEventListener('mouseenter', function () { this.style.background = '#f0f9ff'; });
            li.addEventListener('mouseleave', function () { this.style.background = ''; });
            li.addEventListener('mousedown', function (ev) {
              ev.preventDefault();
              streetInput.value = strasse + (hausnummer ? ' ' + hausnummer : '');
              if (plzInput) plzInput.value = plz;
              if (ortInput) ortInput.value = ort;
              dropdown.style.display = 'none';
            });

            dropdown.appendChild(li);
          });

          dropdown.style.display = dropdown.children.length ? 'block' : 'none';
        })
        .catch(function () { dropdown.style.display = 'none'; });
      }, 350);
    });

    streetInput.addEventListener('blur', function () {
      setTimeout(function () { dropdown.style.display = 'none'; }, 150);
    });
    streetInput.addEventListener('focus', function () {
      if (dropdown.children.length) dropdown.style.display = 'block';
    });
  }

  attachAutocomplete(
    document.getElementById('bulk-strasse'),
    document.getElementById('bulk-plz'),
    document.getElementById('bulk-ort')
  );
  attachAutocomplete(
    document.getElementById('bulk-liefer-strasse'),
    document.getElementById('bulk-liefer-plz'),
    document.getElementById('bulk-liefer-ort')
  );

  showStep(0);
})();
